import combineReducer from "./combineReducer";

import {
  key as SearchKey,
  reducer as SearchReducers,
  actions as SearchActions,
} from "../pages/EntryPoint/context";

import {
  key as ResultsKey,
  reducer as ResultsReducers,
  actions as ResultsActions,
} from "../pages/Results/context";

const rootReducer = combineReducer({
  [SearchKey]: SearchReducers,
  [ResultsKey]: ResultsReducers,
});

const updatedState = (state) => ({
  ...state,
  [SearchKey]: {
    ...state[SearchKey]
  },
  [ResultsKey]: {
    ...state[ResultsKey]
  }
});

const combineActions = (dispatch, state) => ({
  ...SearchActions(dispatch, state),
  ...ResultsActions(dispatch, state),
});

export { rootReducer, updatedState, combineActions };
